import usePaymentSummaryData from "@Modules/eventPage/components/PaymentSummary/utils/usePaymentSummaryData";
import React from "react";
import { useSelector } from "react-redux";
import { SELECTORS } from "@Utils/constants/selectors";
import moduleStyle from "./TotalPayableStrip.module.scss";
import { TOTAL_PAYABLE_TEXT } from "./TotalPayableStrip.constants";

export const TotalPayableStrip = () => {
    const paymentSummaryProps = useSelector(SELECTORS.paymentSummaryProps);

    const { billSummaryProps } = usePaymentSummaryData({
        ...paymentSummaryProps,
    });
    return (
        <div
            id="payable_amount_strip"
            className={`justify-content-between align-items-center d-none ${moduleStyle.text}`}
        >
            <div>{TOTAL_PAYABLE_TEXT}</div>
            <div className={`${moduleStyle.amount}`}>
                {billSummaryProps?.eventCurrencySymbol}&nbsp;
                {billSummaryProps?.totalPrice}
            </div>
        </div>
    );
};
